<template>
  <section>
    <div class="row" v-if="title">
      <div class="col-xs-12">
        <h3>
          {{ title }}
        </h3>
      </div>
    </div>
    <div class="row" v-if="carregando">
      <div class="col-xs-12 datatable-spinner text-center">
        <font-awesome-icon :icon="'spinner'" spin />
      </div>
    </div>
    <div class="row" v-if="!carregando && dados.length">
      <div class="col-xs-12">
        <DataTable
          :fields="fieldsAgendados"
          :slots="['agendado', 'gravidade']"
          :dados="dados"
          :carregando="carregando"
        >
          <template slot="header-actions">
            <ExportCSV :dados="dados" :tipo="'agendados'" />
          </template>
          <template slot="gravidade" slot-scope="props">
            <div
              :class="[getGravidadeClass(props.rowData.gravidade), 'gravidade']"
            >
              {{ props.rowData.gravidade }}
            </div>
          </template>
          <template slot="agendado" slot-scope="props">
            <div
              :class="[
                props.rowData.dtagendamento
                  ? getProximidadeData(props.rowData.dtagendamento) +
                    ' gravidade'
                  : ''
              ]"
            >
              {{ formatTo2DigitsDate(new Date(props.rowData.dtagendamento)) }}
            </div>
          </template>
        </DataTable>
      </div>
    </div>
    <div class="row" v-if="!carregando && !dados.length">
      <div class="col-xs-12 nenhum-item">
        <p>Não há agendamento</p>
      </div>
    </div>
  </section>
</template>

<script>
import {
  getGravidadeClass,
  getProximidadeData,
  fieldsAgendados
} from './datatableFields'
import { NoApiTable as DataTable } from '../common'
import { formatTo2DigitsDate } from '../../utils'
import ExportCSV from './ExportCSV'

export default {
  components: {
    DataTable,
    ExportCSV
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    chave: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getGravidadeClass,
    getProximidadeData,
    formatTo2DigitsDate
  },
  computed: {
    dados() {
      return this.items
    },
    fieldsAgendados() {
      const array = [...fieldsAgendados]

      if (this.chave) {
        array.splice(array.length - 2, 0, {
          name: this.chave,
          title: this.title,
          callback: value => {
            return value.replace(/^.\d+ - /, '')
          }
        })
      }

      return array
    }
  }
}
</script>

<style scoped src="./datatable.css"></style>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/ListaFilaAgendados.vue